var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.isLogged)?_c('div',{staticClass:"container-fluid"},[_c('Search'),_c('Navigation'),_c('router-view')],1):_c('div',[_c('Login')],1),_c('Messenger')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }